import { ITopBarButtonConfig, renderTopBarButton } from './TopBarButton';
import React, { ReactNode } from 'react';

/*
 * render the top bar menu from button configs
 * topBarButtonConfigs: array of button configs to render
 * extras: array of other components
 * */
export const renderTopBarMenu = (
  topBarButtonConfigs: ITopBarButtonConfig[],
  extras: React.ComponentType[] = [],
): Array<ReactNode> => {
  return [
    ...topBarButtonConfigs.map((config, index) => {
      const data: ITopBarButtonConfig = { ...config, key: index };
      return renderTopBarButton(data);
    }),
    ...extras.map((Com, index) => (
      <Com key={topBarButtonConfigs.length + index} />
    )),
  ];
};
